import React from "react";
import { Box, Typography } from "@mui/material";
import "./index.scss";
import { Images } from "../../assets/common";

export default function ProfileMenu({
  actions,
  handleProfileMenuChoice,
  isLast,
  color,
  isHeader,
  right,
}) {
  return (
    <Box
      className="__music_card_menu"
      sx={{
        position: "absolute",
        top: isLast ? isLast : "initial",
        right: right ? right : "initial",
      }}
    >
      {actions.map(({ action, key }, index) =>
        action ? (
          isHeader ? (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "5px 0",
                cursor: "pointer",
                borderBottom: key === "m13" ? "0" : "1px solid #D5D5D5",
              }}
            >
              <img
                style={{ width: key === "m11" ? "16px" : "18px" }}
                src={
                  key === "m11"
                    ? Images.user_black
                    : key === "m13"
                    ? Images.logout
                    : key === "m14"
                    ? Images.notification // Using notification icon for Feedback Hub
                    : key === "m15"
                    ? Images.copy
                    : key === "m16"
                    ? Images.facebook
                    : key === "m17"
                    ? Images.twitter_t
                    : "null"
                }
                alt=""
              />
              <Typography
                className="_cp"
                color={color ? color : "black"}
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  handleProfileMenuChoice(key);
                }}
              >
                {action}
              </Typography>
            </Box>
          ) : (
            <Typography
              className="__music_card_menu_item _cp"
              color={color ? color : "initial"}
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                handleProfileMenuChoice(key);
              }}
            >
              {action}
            </Typography>
          )
        ) : null
      )}
    </Box>
  );
}
